import { DocumentPayloadMap } from 'bff'
import { DocumentVariant } from 'piramid-constants'
import { ComponentType } from 'react'
import AgreementDefault from './default'

type AgreementProps = DocumentPayloadMap['agreement']

/** Layouts por tenant, como `order-report`: sumar una entrada acá y su valor a `documentVariants`. */
const AgreementVariants: Partial<
  Record<DocumentVariant, ComponentType<AgreementProps>>
> = {
  default: AgreementDefault,
}

const Agreement = (props: AgreementProps) => {
  const Variant = AgreementVariants[props.meta.variant] ?? AgreementDefault

  return <Variant {...props} />
}

export default Agreement
